import { useTranslation } from "react-i18next";
import ShipOutlineIcon from "../../icons/shipOutlineIcon";
import TruckIcon from "../../icons/truckIcon";

const WhatMakeUs = () => {
  const { t } = useTranslation();
  return (
    <article className="py-10 bg-white">
      <div className="w-11/12 mx-auto ">
        <h1 className="font-bold text-mainBlue text-[24px] text-center md:text-[32px] mb-8">
          {t("WhatMakeUS")}
        </h1>
        <p className="text-mainGray md:text-[18px] text-center">
          {t("yourReliablePartner")}
        </p>
        <section className="grid grid-cols-1 gap-8 my-10 md:grid-cols-2 lg:grid-cols-3">
          <div className="p-8 space-y-5 shadow-lg rounded-2xl">
            <h1 className="flex items-center gap-2 text-2xl font-bold">
              <ShipOutlineIcon /> {t("seaShipping")}
            </h1>
            <p className="text-mainGray">{t("bestForLargeShipments")}</p>
          </div>
          <div className="p-8 space-y-5 shadow-lg rounded-2xl">
            <h1 className="flex items-center gap-2 text-2xl font-bold">
              <TruckIcon fill="#0051FF" />
              {t("landShipping")}
            </h1>
            <p className="text-mainGray">{t("fastAndFlexible")}</p>
          </div>
          <div className="p-8 space-y-5 shadow-lg rounded-2xl">
            <h1 className="flex items-center gap-2 text-2xl font-bold">
              <TruckIcon fill="#0051FF" />
              {t("airFreight")}
            </h1>
            <p className="text-mainGray">{t("FastestForAgents")}</p>
          </div>
        </section>
      </div>
    </article>
  );
};

export default WhatMakeUs;
